import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import FlagProvider, { IConfig } from '@unleash/proxy-client-react';

import { unleashUrl } from '../config/environment';
import { Layout } from '../pages/Layout';
import { Maintenance } from '../pages/Maintenance';
import { CustomRoutes } from '../pages/Routes';
import { ToastProvider } from '../projects/components/Toast/ToastProvider';
import { AppStateContextProvider } from '../providers/AppContext/AppContext';
import { LocalStorageContextProvider } from '../providers/LocalStorageContext';
import { ReduxStoreProvider } from '../providers/ReduxStoreContext';
import { SessionStorageContextProvider } from '../providers/SessionStorageContext';
import { UserProfileContextProvider } from '../providers/UserProfileContext/UserProfileContext';
import { getInitialLocale } from '../services/locale';
import { LocalisationContextProvider } from '../services/localisationContext';
import { defaultTheme } from '../styled/defaultTheme';
import { Initialization } from './Initialization';
import { setupResponsiveness } from './setupResponsiveness';

setupResponsiveness();

const unleashConfig: IConfig = {
  url: unleashUrl,
  appName: 'wsc-configurator',
  /**
   * The clientKey is used to clean Authorization header in api-gateway.
   * The real value and metrics will be used when unleash-proxy gets deployed.
   */
  clientKey: 'unleash',
  refreshInterval: 60,
  disableMetrics: true,
};

const App: React.FC = () => (
  <Router>
    <FlagProvider config={unleashConfig}>
      <ThemeProvider theme={defaultTheme}>
        <Maintenance>
          <LocalStorageContextProvider>
            <SessionStorageContextProvider>
              <AppStateContextProvider>
                <LocalisationContextProvider initialLocale={getInitialLocale()}>
                  <ToastProvider>
                    <ReduxStoreProvider>
                      <UserProfileContextProvider>
                        <Initialization>
                          <Layout>
                            <CustomRoutes />
                          </Layout>
                        </Initialization>
                      </UserProfileContextProvider>
                    </ReduxStoreProvider>
                  </ToastProvider>
                </LocalisationContextProvider>
              </AppStateContextProvider>
            </SessionStorageContextProvider>
          </LocalStorageContextProvider>
        </Maintenance>
      </ThemeProvider>
    </FlagProvider>
  </Router>
);

export default App;
